export default __webpack_public_path__ + "static/media/defence_background.04d6903a.jpg";